<template>
  <div class="companyinfo">
    <div class="companyinfo-top">
      <div class="desc flexfs">
        <img v-if="companyDetail&&companyDetail.logo" :src="companyDetail.logo" class="mr-56" />
        <img v-else class="mr-56" src="@/assets/img/user/company_default_back.png" />
        <div>
          <p class="font24 fontbig mb-28">{{ companyDetail.name }}</p>
          <p>
            <span class="mr-8">
              <Icon type="ios-call" />
            </span>
            <span class="mr-32 font16">{{ companyDetail.contactPhone || form.phone }}</span>
            <span class="mr-8">
              <Icon type="ios-mail" />
            </span>
            <span class="font16">{{ companyDetail.contactEmail || form.email }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="companyinfo-btm carddom mt-16">
      <Tabs v-model="activeTab">
        <TabPane label="所有服务" name="all"></TabPane>
        <TabPane label="服务商简介" name="introduce"></TabPane>
      </Tabs>
      <div v-show="activeTab == 'all'">
        <div class="flexsb sort" v-if="serviceList && serviceList.length != 0">
          <div class="flexfs">
            <p class="mr-48 flexcenter">
              <span
                :class="
                  activeSort.name == 'usedAmount'
                    ? 'fontblue fontcursor'
                    : 'fontcursor'
                "
                @click="sort('usedAmount')"
              >使用量</span>
              <img v-show="activeSort.name != 'usedAmount'" src="@/assets/img/service/sort.svg" alt />
              <img
                v-show="activeSort.name == 'usedAmount' && activeSort.sort == 'asc'"
                src="@/assets/img/service/sort-up.svg"
                alt
              />
              <img
                v-show="activeSort.name == 'usedAmount' && activeSort.sort == 'desc'"
                src="@/assets/img/service/sort-down.svg"
                alt
              />
            </p>
            <p class="mr-48 flexcenter">
              <span
                :class="
                  activeSort.name == 'createTime'
                    ? 'fontblue fontcursor'
                    : 'fontcursor'
                "
                @click="sort('createTime')"
              >发布时间</span>
              <img v-show="activeSort.name != 'createTime'" src="@/assets/img/service/sort.svg" alt />
              <img
                v-show="activeSort.name == 'createTime' && activeSort.sort == 'asc'"
                src="@/assets/img/service/sort-up.svg"
                alt
              />
              <img
                v-show="activeSort.name == 'createTime' && activeSort.sort == 'desc'"
                src="@/assets/img/service/sort-down.svg"
                alt
              />
            </p>
            <p class="flexcenter">
              <span
                :class="
                  activeSort.name == 'score'
                    ? 'fontblue fontcursor'
                    : 'fontcursor'
                "
                @click="sort('score')"
              >评分</span>
              <img v-show="activeSort.name != 'score'" src="@/assets/img/service/sort.svg" alt />
              <img
                v-show="activeSort.name == 'score' && activeSort.sort == 'asc'"
                src="@/assets/img/service/sort-up.svg"
                alt
              />
              <img
                v-show="activeSort.name == 'score' && activeSort.sort == 'desc'"
                src="@/assets/img/service/sort-down.svg"
                alt
              />
            </p>
          </div>
          <p class="ml-16 fontcursor" @click="isList = !isList">
            <img class="w24px" src="@/assets/img/service/listCard.png" alt />
          </p>
        </div>
        <!-- <div class="mt-20" style="border:1px solid #F6F7F9"></div> -->
        <Row :gutter="24" class="mt-24" v-if="isList == false">
          <Col span="6" class="mb-24" v-for="(item, index) in serviceList" :key="index">
            <ServeCard :item="{...item}" @click.native="link('/servepro/serveinfo', item)" />
          </Col>
        </Row>
        <div class="mt-30" v-if="serviceList && serviceList.length != 0 && isList">
          <aiItem
            class="aiitem mb-24"
            v-for="(item, index) in serviceList"
            :item="item"
            :key="index"
            @click.native="link('/servepro/serveinfo', item)"
          />
        </div>
        <Row
          class="mt-16"
          type="flex"
          justify="center"
          v-if="serviceList && serviceList.length != 0"
        >
          <Page
            :total="total"
            :page-size="search.pageSize"
            :page-size-opts="psize"
            :current="search.pageIndex"
            @on-change="handlePage"
            @on-page-size-change="sizeChange"
            show-sizer
            show-total
            show-elevator
            placement="top"
          />
        </Row>
        <div v-if="serviceList.length == 0" class="serveEmpty">
          <img src="@/assets/img/serveuse/serveuse_null_default.png" alt />
          <p class="fontthreedark">暂未发布服务</p>
        </div>
      </div>
      <div class="companyinfo-introduce" v-show="activeTab == 'introduce'">
        <!-- <img class="w100" src="@/assets/img/service/company_info.png" alt="" /> -->
        <p class="mt-30">{{ companyDetail.introduce }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import aiItem from "@/components/card/ai-item.vue";
import { getServePubilshlist } from "@/api/servicePro";
import ServeCard from "@/components/card/ServeCard.vue";

export default {
  name: "",
  components: {
    aiItem,
    ServeCard
  },
  props: {},
  data() {
    return {
      isList: true,
      companyId: "1",
      activeTab: "all",
      companyDetail: {},
      serviceList: [],
      form: {
        name: "泰山信息科技有限公司",
        phone: "0531-88881234",
        email: "ts-it@ts-it.cn"
      },
      search: {},
      activeSort: {
        name: "usedAmount",
        sort: "desc"
      }, //排序选中
      sortObj: {
        useSort: true,
        timeSort: true,
        scoreSort: true
      },
      psize: [4, 8, 12],
      total: 0,
      search: {
        pageIndex: 1,
        pageSize: 4
      }
    };
  },
  watch: {
    //解决当前页最后一条删除后，没有自动折页的问题
    total() {
      const cPage = this.total / this.search.pageSize;
      if (this.search.pageIndex === cPage + 1 && this.search.pageIndex != 1) {
        this.search.pageIndex = this.search.pageIndex - 1;
        this.getServePubilshlist(); //获取列表数据
      }
    }
  },
  created() {
    this.companyId = this.$route.query.id;
    this.search.orderBy = "usedAmount:desc";
    console.log("this.companyId", this.companyId);
    this.getServePubilshlist();
  },
  methods: {
    //排序
    sort(name) {
      let type;
      // let item = this.sortObj;
      //true为升序
      // if (name == "usedAmount") {
      //   item.useSort = !item.useSort;
      //   type = item.useSort ? "asc" : "desc";
      //   type = "desc";
      // } else if (name == "createTime") {
      //   item.timeSort = !item.timeSort;
      //   type = item.timeSort ? "asc" : "desc";
      //   type = "desc";
      // } else {
      //   item.scoreSort = !item.scoreSort;
      //   type = item.scoreSort ? "asc" : "desc";
      //   type = "desc";
      // }
      if(name == this.activeSort.name) {
        type = this.activeSort.sort == "desc"? "asc": "desc"
      } else {
        type = "desc"
      }
      this.activeSort = {
        name: name,
        sort: type
      };
      this.search.orderBy = name + ":" + type;
      console.log("this.search", this.search);
      this.getServePubilshlist();
    },
    link(path, item) {
      if (item) {
        this.$router.push({
          path: path,
          query: {
            id: item.id
          }
        });
      } else {
        this.$router.push({ path: path });
      }
    },
    // 获取发布服务列表数据
    getServePubilshlist() {
      getServePubilshlist(this.search, this.companyId).then(res => {
        this.companyDetail = res.data.data.organInfo; //企业详情
        console.log("this.companyDetail", this.companyDetail);
        this.serviceList = res.data.data.services; //服务列表
        this.total = res.data.page.totalCount;
        console.log("this.servicePublishList", res);
      });
    },
    // 分页（第几页）
    handlePage(value) {
      this.search.pageIndex = value;
      this.getServePubilshlist();
    },
    // 分页（每页的条数）
    sizeChange(value) {
      this.search.pageSize = value;
      this.getServePubilshlist();
    }
  }
};
</script>

<style lang="scss">
.companyinfo {
  width: 100%;
  &-top {
    width: 100%;
    background: #fff;
    box-shadow: 0px 2px 10px 0px rgba(186, 187, 189, 0.05);
    border-radius: 8px;
    .bread {
      border-bottom: 1px solid #f6f7f9;
      padding: 14px 32px;
      color: #919caf;
    }
    .desc {
      padding: 30px 32px;
      img {
        width: 180px;
        height: 150px;
      }
    }
  }
  &-btm {
    .aiitem {
      width: 100%;
    }
    .serveEmpty {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      p {
        width: 100%;
        text-align: center;
      }
    }
  }
  &-introduce {
    color: #67799c;
  }
}
</style>
